import { RealestateTags } from "./tagEnums";

export enum Forms {
  BANK = "bank",
  BANK2 = "bank2",
  PENSION = "pension",
  SHARE = "share",
  CRYPTO = "crypto",
  DEBT = "debt",
  REALESTATE = "realestate",
  RSU = "rsu",
  OTHER = "other",
}

/** A saved product can have a blank name; id is what distinguishes edit from create. */
export const isSavedProduct = (product?: { id?: unknown } | null) =>
  product?.id !== undefined && product?.id !== null && product?.id !== "";

/**
 * Category used for display (assets map, filters, tables).
 * Land is entered via the Other form (simpler fields) but belongs under Real Estate.
 */
export const getDisplayCategoryForm = (product: {
  form?: string;
  tag?: string;
}): Forms | string => {
  if (product?.form === Forms.OTHER && product?.tag === RealestateTags.LAND) {
    return Forms.REALESTATE;
  }
  return product?.form ?? Forms.OTHER;
};
